import React from "react";
import Road_Parivar_Banner from "../about_us/road_parivar_banner/Road_Parivar_Banner";
import Our_Serviceses from "./our_serviceses/Our_Serviceses";

function Services() {
  return (
    <>
      <Road_Parivar_Banner fullscreen={true}/>
      <Our_Serviceses />
    </>
  );
}
export default Services;
